import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { api } from "@/lib/api";
import Seo from "@/components/Seo";
import { StarAuthShell } from "@/pages/star/StarLayout";

export default function StudentForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/student/forgot-password", { email: email.trim() });
      setDone(true);
      toast.success(data.message || "If an account exists, a reset link has been sent.");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Something went wrong. Please try again.");
    } finally { setLoading(false); }
  };

  return (
    <StarAuthShell title="Forgot password" subtitle="We'll email a secure reset link to your registered parent/guardian email.">
      <Seo title="Forgot Password" />
      {done ? (
        <div className="mt-6 space-y-4" data-testid="student-forgot-done">
          <div className="rounded-xl border border-blue-200 bg-blue-50 p-4 text-sm text-blue-900">
            If an account exists for that email, a single-use password reset link has been sent. It is valid for 1 hour. Please check your inbox (and spam).
          </div>
          <Link to="/student/login" className="block text-center font-semibold text-blue-900 hover:underline" data-testid="student-forgot-back">Back to sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="student-forgot-form">
          <div>
            <Label className="mb-1.5 block font-semibold text-slate-700">Parent/Guardian email</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="parent@example.com" data-testid="student-forgot-email" required />
            <p className="mt-1.5 text-xs text-slate-500">For your security, resets are only sent to the verified email on your account. A roll number alone cannot reset a password. If you don't have an email on file, contact your admin for assisted recovery.</p>
          </div>
          <Button type="submit" disabled={loading} className="w-full h-11 bg-blue-900 hover:bg-blue-950" data-testid="student-forgot-submit">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send reset link"}
          </Button>
          <Link to="/student/login" className="block text-center text-sm font-semibold text-blue-900 hover:underline">Back to sign in</Link>
        </form>
      )}
    </StarAuthShell>
  );
}
